import { Center, Icon } from "@chakra-ui/react";
import { ReactIdenticon } from "@umami/components";
import { type ImplicitAccount } from "@umami/core";

import {
  EnvelopeIcon,
  FacebookIcon,
  GoogleIcon,
  KeyIcon,
  RedditIcon,
  TwitterIcon,
  USBIcon,
} from "../../assets/icons";
import { useColor } from "../../styles/useColor";

export const AccountTileIcon = ({
  size = 30,
  account,
}: {
  size?: number;
  account: ImplicitAccount;
}) => {
  const color = useColor();

  switch (account.type) {
    case "ledger":
      return (
        <Icon
          as={USBIcon}
          width="32px"
          height="32px"
          color={color("600")}
          data-testid="account-tile-icon-usb"
        />
      );
    case "mnemonic":
      return (
        <Center borderRadius="full">
          <ReactIdenticon
            background="white"
            data-testid="account-tile-icon-identicon"
            size={size}
            string={account.address.pkh}
          />
        </Center>
      );
    case "social": {
      switch (account.idp) {
        case "facebook":
          return <FacebookAccountIcon />;
        case "google":
          return <GoogleAccountIcon data-testid="account-tile-icon-google" />;
        case "twitter":
          return <TwitterAccountIcon />;
        case "email":
          return (
            <Icon
              as={EnvelopeIcon}
              width="28px"
              height="28px"
              color={color("600")}
              data-testid="account-tile-icon-envelope"
            />
          );
        case "reddit":
          return <RedditAccountIcon data-testid="account-tile-icon-reddit" />;
        case "apple":
          throw new Error("Apple auth is not supported yet");
      }
    }
    // eslint-disable-next-line no-fallthrough
    case "secret_key":
      return (
        <Icon
          as={KeyIcon}
          width="28px"
          height="28px"
          color={color("600", "white")}
          data-testid="account-tile-icon-key"
        />
      );
  }
};

export const FacebookAccountIcon = (props: any) => (
  <Icon as={FacebookIcon} width="48px" height="48px" {...props} />
);

export const GoogleAccountIcon = (props: any) => (
  <Icon as={GoogleIcon} width="48px" height="48px" {...props} />
);

export const TwitterAccountIcon = (props: any) => (
  <Icon as={TwitterIcon} width="28px" height="28px" {...props} />
);

export const RedditAccountIcon = (props: any) => (
  <Icon as={RedditIcon} width="28px" height="28px" {...props} />
);
